import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(() => api.get("/auth/me").then((r) => { setUser(r.data); return r.data; }).catch(() => { setUser(false); return false; }), []);
  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  }, []);

  const register = useCallback(async (name, email, password, referral_code = "", accept_terms = false, confirm_age = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, referral_code, accept_terms, confirm_age });
    setUser(data);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  }, []);

  return <Ctx.Provider value={{ user, login, register, logout, refreshUser }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
